import { FC } from 'react';
import { connect } from 'react-redux';
import { useIntl, defineMessages } from 'dibs-react-intl';

import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import HeartIcon from 'dibs-icons/exports/HeartOutlined';
import styles from './Likes-style.scss';
import classNames from 'classnames';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'my favorites|my favorites header icon',
};

type ReduxStoreType = {
    header: {
        isNavigationRefreshVariant: boolean;
    };
};

type Props = {
    onMouseEnter?: () => void;
    favoritesUrl?: string;
    hasUnread?: boolean;
    isNavigationRefreshVariant: boolean;
};
const messages = defineMessages({
    label: { id: 'dbl.Header.LikesIcon.label', defaultMessage: 'Favorites' },
});
const LikesIcon: FC<Props> = ({
    onMouseEnter,
    favoritesUrl,
    hasUnread = false,
    isNavigationRefreshVariant,
}) => {
    const intl = useIntl();
    const iconWrapperClassName = classNames(styles.iconWrapper, {
        [styles.navigationRefreshWrapper]: isNavigationRefreshVariant,
    });
    const iconClassName = classnames(styles.icon, {
        [styles.hasUnread]: hasUnread,
    });

    return (
        <div className={iconWrapperClassName} onMouseEnter={onMouseEnter}>
            <Link
                ariaLabel={intl.formatMessage(messages.label)}
                dataTn="likes-link"
                href={favoritesUrl}
                className={iconClassName}
                onClick={event => {
                    trackEvent(trackingObj, event);
                }}
            >
                <HeartIcon />
            </Link>
        </div>
    );
};

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isNavigationRefreshVariant: boolean;
} => {
    const { isNavigationRefreshVariant } = header;
    return {
        isNavigationRefreshVariant,
    };
};

export default connect(mapStateToProps)(LikesIcon);
